import { NotifyHelper } from "../../../helpers/toast";
import { eThamSoHeThongActionsObj } from "../../action-types/category/IThamSoHeThongActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const thamSoHeThongActions = {
    ...generateActions(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG"),
    ...generateActionForKey(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG", "LOAD_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG", "UPDATE_ACTIVE_STATUS_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG", "UPDATE_ACTIVE_STATUS_SUCCESS", () => { NotifyHelper.Success("Cập nhật thành công") }),
    ...generateActionForKey(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG", "UPDATES_ERROR", (m) => { NotifyHelper.Error(m) }),
    ...generateActionForKey(eThamSoHeThongActionsObj, "THAM_SO_HE_THONG", "UPDATES_SUCCESS", (m) => { NotifyHelper.Success(m) }),
}